(() => {
  const DEBUG = true

  const LOGGER = (content, type) => {
    if (DEBUG) {
      if (console[type]) {
        console[type](content)
      } else {
        console.log(content)
      }
    }
  }

  const FEATURE_KEYS = ['width_1','width_2','width_3', 'orientation']
  const PRODUCTS_USE_WIDTH = ['Sofa', 'Loveseat', 'Ottoman', 'Sofa with Chaise', 'Sofa with Bumper', 'Modular Piece']

  let FRAMES
  if (window.spsProductType.includes('Sectional')) {
    FRAMES = ['1', '30', '25', '13']
  } else {
    FRAMES = ['1', '30', '25', '20']
  }
  const FRAMES_REVERSED = ['1', '5', '9', '21']

  if (!customElements.get("td-cylindo-wrapper")) {
    class TDCylindoWrapper extends HTMLElement {
      constructor() {
        super();
        
        this.CYLINDO_CUSTOMER_ID = this.dataset.cylindoCustomer
        this.LOADER = this.querySelector('[data-loader]')
        this.CYLINDO_WRAPPER = this.querySelector('[data-cylindo-wrapper]')

        this.cylindoViewer = undefined
        this.cylindoProduct = this.dataset.cylindoProduct
        this.isLoading = false
  
      }

      getInstanceAttributes() {
        return {
          "Element": this.nodeName,
          "Customer ID": this.CYLINDO_CUSTOMER_ID,
          "Product": this.cylindoProduct,
          "Loading": this.isLoading,
        }
      }
  
      connectedCallback() {
        if (this.CYLINDO_WRAPPER  && this.CYLINDO_CUSTOMER_ID && this.cylindoProduct) {
          this.bindCylindoEvents()
          this.bindCustomizerEvents()
          this.bindEvents()
        }
        
      }
      bindCylindoEvents() {
        customElements.whenDefined("cylindo-viewer").then(() => {
          if (this.querySelector("cylindo-viewer")) {
            // viewer already initialized
            return;
          }
          this.cylindoViewer = document.createElement('cylindo-viewer')
          this.CYLINDO_WRAPPER.appendChild(this.cylindoViewer)

          Object.assign(this.cylindoViewer, {
            'code': this.cylindoProduct,
            'customer-id': this.CYLINDO_CUSTOMER_ID,
            'interaction-hiding-delay': "Infinity",
            'controls': "zoom indicators",
            'show-zoom-controls-on-touch':true,
            'ignore-unknown-features':true
          })

          customElements.whenDefined('cylindo-viewer').then(() => {
            document.dispatchEvent(new CustomEvent('td:cylindo-loaded'))
          })
        });
      }
      bindCustomizerEvents() {
        document.addEventListener('td:color-changed', this.handleCustomizerChange.bind(this))
        document.addEventListener('td:product-selected', this.handleCustomizerChange.bind(this))
        
      }
      handleCustomizerChange({detail}) {
        
        if (this.cylindoViewer) {
          const newFeatures = {}
          
          // Check if dimensions exist in the detail object
          const dimensions = detail.product.dimensions;
          
          if ((dimensions && dimensions.find((dimension) => dimension.hasOwnProperty('width_2'))) || PRODUCTS_USE_WIDTH.includes(window.spsProductType)) {
            FEATURE_KEYS.forEach((key) => {
              const foundDimension = dimensions && dimensions.find((dimension) => dimension[key]);
              if (foundDimension) {
                const transformedKey = key.replace(/_/gm,' ').toUpperCase()
                newFeatures[transformedKey] = foundDimension[key]
              } else if (key == 'orientation') {
                const foundOrientation = detail.product.orientation
                if (foundOrientation) {
                  newFeatures['ORIENTATION'] = foundOrientation.replace(/_/gm,' ')
                }
              }
            });
          }

          // OVVERIDES FOR PILLOWS
          if (window.spsProductType == 'Pillows' && dimensions && dimensions.find((dimension) => dimension.hasOwnProperty('pillow_size'))) {
            let pillow_size = dimensions.find((dimension) => dimension.hasOwnProperty('pillow_size'))['pillow_size']
            newFeatures["PILLOW SIZE"] = pillow_size.replace(/"/g, '”');;
          }

          // OVERRIDES FOR BENCHES/CHAIRS WITH WIDTH
          if (window.spsProductType == 'Chair' && dimensions && dimensions.find((dimension) => dimension.hasOwnProperty('width_1'))) {
            let width_1 = dimensions.find((dimension) => dimension.hasOwnProperty('width_1'))['width_1']
            newFeatures["WIDTH 1"] = width_1;
          }

          // OVERRIDES FOR SECTIONAL WITH CHAISE
          if (window.spsProductType.toLowerCase() == 'sectional with chaise') {
            delete newFeatures["WIDTH 2"];
          }
            
          // OVERRIDES FOR OTTOMAN
          if (window.spsProductType == 'Ottoman' && dimensions && dimensions.find((dimension) => dimension.hasOwnProperty('depth'))) {
            let depthSize = dimensions.find((dimension) => dimension.hasOwnProperty('depth'))['depth'];
            newFeatures['DEPTH SIZE'] = depthSize;
          }
          // OVERRIDES FOR BED
          if (window.spsProductType == 'Bed' && dimensions && dimensions.find((dimension) => dimension.hasOwnProperty('bed_size'))) {
            let bedSize = dimensions.find((dimension) => dimension.hasOwnProperty('bed_size'))['bed_size'];
            newFeatures['OPTION1 VALUE'] = bedSize.toUpperCase();
          }
          if (dimensions && dimensions.find((dimension) => dimension.hasOwnProperty('headboard_height'))) {
            let headboardHeight = dimensions.find((dimension) => dimension.hasOwnProperty('headboard_height'))['headboard_height']
            newFeatures['HEADBOARD HEIGHT'] = headboardHeight.split('(')[0].trim().toUpperCase();
          }
          if (detail.fabric) {
            newFeatures['UPHOLSTERY'] = detail.fabric.sku
          }
          if (detail.leg) {
            newFeatures['LEG FINISH'] = detail.leg.sku
          }

          if (document.querySelector('td-cylindo-open-trigger[data-is-open="OPEN"]')) {
            newFeatures['VIEW'] = 'OPEN'
          }
          
          this.cylindoViewer.features = {...this.cylindoViewer.features, ...newFeatures}
          document.dispatchEvent(new CustomEvent("td:display-cylindo"))
        }
      }
      bindEvents() {
        document.addEventListener('td:cylindo-frame-trigger', this.handleFrameChange.bind(this))
        document.addEventListener('td:cylindo-open-trigger', this.handleCustomizerOpen.bind(this))
      }
      handleFrameChange({detail}) {
        if (this.cylindoViewer) {
          this.cylindoViewer.animateToFrame(detail.frame)
        }
      }
      handleCustomizerOpen({detail}) {
        if (this.cylindoViewer) {
          this.cylindoViewer.features = {
            ...this.cylindoViewer.features,
            "VIEW": detail.open ? "OPEN" : "CLOSE"
          }
        }
      }
    }
    
    customElements.define('td-cylindo-wrapper', TDCylindoWrapper);
  }

  if (!customElements.get("td-cylindo-frame-trigger")) {

    class TDCylindoFrameTrigger extends HTMLElement {
      constructor() {
        super();
        
        this.CYLINDO_CUSTOMER_ID = this.dataset.cylindoCustomer
        this.CYLINDO_COVER_MOBILE = document.querySelector('[data-cylindo-cover-mobile]')
        this.CYLINDO_COVER_DESKTOP = document.querySelector('[data-cylindo-cover-desktop]')
        this.CYLINDO_OPEN_TRIGGERS = document.querySelectorAll('td-cylindo-open-trigger')
        this.FRAME = this.dataset.frame
        this.ITERATION = this.dataset.iteration;
        this.URL_TEMPLATE = this.dataset.urlTemplate
        this.IMAGE = this.querySelector('img')
        
        this.cylindoProduct = this.dataset.cylindoProduct
        this.orientation;
        this.currentFrame = '1'
        this.isOpen = false
        this.isRequestInProgress = false
      }

      getInstanceAttributes() {
        return {
          "Element": this.nodeName,
          "Customer ID": this.CYLINDO_CUSTOMER_ID,
          "Product": this.cylindoProduct,
          "Frame": this.FRAME,
          "Url Template": this.URL_TEMPLATE
        }
      }
  
      connectedCallback() {
        if (this.CYLINDO_CUSTOMER_ID && this.FRAME && this.cylindoProduct) {
          this.bindCustomizerEvents()
          this.bindEvents()
        }
      }

      bindCustomizerEvents() {
        document.addEventListener('td:color-changed', this.handleCustomizerChange.bind(this))
        document.addEventListener('td:product-selected', this.handleCustomizerChange.bind(this))
      }
      handleCustomizerChange({detail}) {
        const featureFragments = []

        
        // Check if dimensions exist in the detail object
        const dimensions = detail.product.dimensions;

        if ((dimensions && dimensions.find((dimension) => dimension.hasOwnProperty('width_2'))) || PRODUCTS_USE_WIDTH.includes(window.spsProductType)) {
          FEATURE_KEYS.forEach((key) => {
            const foundDimension = dimensions && dimensions.find((dimension) => dimension[key]);
            if (foundDimension) {
              featureFragments.push(`${key.replace(/_/gm, '%20').toUpperCase()}:${encodeURIComponent(foundDimension[key])}`.toUpperCase())
            }
            if (key == 'orientation') {
              const foundOrientation = detail.product.orientation
              if (foundOrientation) {
                featureFragments.push(`${key.replace(/_/gm, '%20').toUpperCase()}:${encodeURIComponent(foundOrientation.replace(/_/gm,' '))}`.toUpperCase())
              }
            }
          })
        }
        if (window.spsProductType == 'Chair' && dimensions && dimensions.find((dimension) => dimension.hasOwnProperty('width_1'))) {
          let width_1 = dimensions.find((dimension) => dimension.hasOwnProperty('width_1'))['width_1']
          featureFragments.push(`WIDTH%201:${encodeURIComponent(width_1)}`)
        }
        if (window.spsProductType.toLowerCase() == 'sectional with chaise') {
          const index = featureFragments.findIndex(str => str.includes('WIDTH%202'));
          if (index !== -1) {
            featureFragments.splice(index, 1);
          }
        }
        if (window.spsProductType == 'Ottoman' && dimensions && dimensions.find((dimension) => dimension.hasOwnProperty('depth'))) {
          let depthSize = dimensions.find((dimension) => dimension.hasOwnProperty('depth'))['depth']
          featureFragments.push(`DEPTH%20SIZE:${encodeURIComponent(depthSize)}`)
        }
        if (detail.fabric) {
          featureFragments.push(`UPHOLSTERY:${encodeURIComponent(detail.fabric.sku)}`)
        }
        if (detail.leg) {
          featureFragments.push(`LEG%20FINISH:${encodeURIComponent(detail.leg.sku)}`)
        }
        // OVERRIDES FOR BED
        if (window.spsProductType == 'Bed' && dimensions && dimensions.find((dimension) => dimension.hasOwnProperty('bed_size'))) {
          let bedSize = dimensions.find((dimension) => dimension.hasOwnProperty('bed_size'))['bed_size'].toUpperCase();
          featureFragments.push(`OPTION1%20VALUE:${encodeURIComponent(bedSize)}`)
        }
        if (dimensions && dimensions.find((dimension) => dimension.hasOwnProperty('headboard_height'))) {
          let headboardHeight = dimensions.find((dimension) => dimension.hasOwnProperty('headboard_height'))['headboard_height'].split('(')[0].trim().toUpperCase()
          featureFragments.push(`HEADBOARD%20HEIGHT:${encodeURIComponent(headboardHeight)}`)
        }

          // OVVERIDES FOR PILLOWS
          if (window.spsProductType == 'Pillows' && dimensions && dimensions.find((dimension) => dimension.hasOwnProperty('pillow_size'))) {
            let pillow_size = dimensions.find((dimension) => dimension.hasOwnProperty('pillow_size'))['pillow_size']
            featureFragments.push(`PILLOW%20SIZE:${encodeURIComponent(pillow_size.replace(/"/g, '”'))}`)
          }

        if (this.orientation && this.orientation.includes('Right')) {
          this.currentFrame = FRAMES_REVERSED[this.ITERATION]
        } else {this.currentFrame = FRAMES[this.ITERATION]}

        let newURL = this.URL_TEMPLATE.slice(0).replace('**customer**',this.CYLINDO_CUSTOMER_ID).replace('**product**',this.cylindoProduct).replace('**frame**', this.currentFrame) + '&ignoreunknownfeatures=true'
        
        // TODO, refactor this, this is a bad pattern
        if (document.querySelector('td-cylindo-open-trigger')) {
          featureFragments.push(`VIEW:${this.isOpen ? 'OPEN': 'CLOSE'}`)
        }

        if (newURL.includes('?')) {
          newURL += `&feature=${featureFragments.join('&feature=')}`
        } else {
          newURL += `?feature=${featureFragments.join('&feature=')}`
        }

        this.requestRenderingUpdate(newURL)
       
      }
      requestRenderingUpdate(newURL) {
        // If a request is already in progress, don't start another one
        if (this.isRequestInProgress) {
          LOGGER('Rendering update already in progress, ignoring new request', 'warn')
          return
        }
        
        // Set flag to indicate a request is in progress
        this.isRequestInProgress = true
        
        fetch(newURL).then(response => {
          if (response.status === 404) {
            document.dispatchEvent(new CustomEvent('td:cylindo-image-set',{detail: {image: null}}))
            if (this.CYLINDO_COVER_MOBILE && this.CYLINDO_COVER_DESKTOP) {
              this.CYLINDO_COVER_MOBILE.style.opacity = '1';
              this.CYLINDO_COVER_MOBILE.style.zIndex = 0;
              this.CYLINDO_COVER_DESKTOP.style.opacity = '1';
              this.CYLINDO_COVER_DESKTOP.style.zIndex = 0;
            }
            if (this.CYLINDO_OPEN_TRIGGERS.length) {
              this.CYLINDO_OPEN_TRIGGERS.forEach((trigger) => {
                trigger.classList.toggle('td--trigger-hidden', true)
              })
            }
          } else {
            if (this.CYLINDO_COVER_MOBILE && this.CYLINDO_COVER_DESKTOP) {
              this.CYLINDO_COVER_MOBILE.style.opacity = '0';
              this.CYLINDO_COVER_MOBILE.style.zIndex = -1;
              this.CYLINDO_COVER_DESKTOP.style.opacity = '0';
              this.CYLINDO_COVER_DESKTOP.style.zIndex = -1;
            }
            if (this.CYLINDO_OPEN_TRIGGERS.length) {
              this.CYLINDO_OPEN_TRIGGERS.forEach((trigger) => {
                trigger.classList.toggle('td--trigger-hidden', false)
              })
            }
            this.IMAGE.src = newURL
            if (this.FRAME == 1) {
              // NOTE stripping feature=VIEW:
              document.dispatchEvent(new CustomEvent('td:cylindo-image-set',{detail: {image: newURL.split('feature=VIEW:')[0]}}))
            }
          }
        })
        .finally(() => {
          // Reset the flag when the request is complete (success or error)
          this.isRequestInProgress = false
        })
      }
      bindEvents() {
        this.addEventListener('click', this.handleClick.bind(this))
        document.addEventListener('td:cylindo-open-trigger', this.handleCustomizerOpen.bind(this))
      }
      handleClick() {
        let frame;
        if (this.orientation && this.orientation.includes('Right')) {
          frame = FRAMES_REVERSED[this.ITERATION]
        } else {frame = FRAMES[this.ITERATION]}
        
        document.dispatchEvent(new CustomEvent("td:custom-thumbnail-change", {detail: {newIndex: 0}}))
        document.dispatchEvent(new CustomEvent("td:cylindo-frame-trigger",{bubbles:true,detail:{frame: frame}}))
      }
      handleCustomizerOpen({detail}) {
      
        this.isOpen = detail.open || false
        const imageSrc = this.IMAGE.src
        const featureKey = 'VIEW:'
        const param = `feature=${featureKey}${this.isOpen ? "OPEN": "CLOSE" }`
        if (imageSrc.includes(featureKey)) {
          // NOTE inverting as the value would be the opposite
          const replacementString = `feature=${featureKey}${!this.isOpen ? "OPEN": "CLOSE" }`
          const newUrl = `${this.IMAGE.src}`.replace(replacementString, param)
          this.requestRenderingUpdate(newUrl)

        } else {
          const joinString = imageSrc.includes('?') ? '&' : '?'
          const newUrl = [this.IMAGE.src, param].join(joinString)
          this.requestRenderingUpdate(newUrl)
        }

      }
    }
    customElements.define('td-cylindo-frame-trigger', TDCylindoFrameTrigger);
  }


  if (!customElements.get("td-cylindo-open-trigger")) {

    class TDCylindoOpenTrigger extends HTMLElement {
      constructor() {
        super();

        this.INPUT_ELEMENT = this.querySelector('input')
        this.DEFAULT_STATE = this.dataset.isOpen
      }
  
      connectedCallback() {
        if (this.INPUT_ELEMENT) {
          this.bindEvents()
          // NOTE Cylindo is defaulting to Close, if it's open trip and emit
          if (this.DEFAULT_STATE == 'OPEN') {
            this.INPUT_ELEMENT.checked = true
            this.handleChange()
          }
        }
      }
      bindEvents() {
        this.INPUT_ELEMENT.addEventListener('change', this.handleChange.bind(this))
        document.addEventListener('td:cylindo-open-trigger', this.handleOtherElementChange.bind(this))
      }
      handleChange() {
        document.dispatchEvent(new CustomEvent("td:cylindo-open-trigger",{bubbles:true,detail:{open: this.INPUT_ELEMENT.checked}}))
      }
      handleOtherElementChange({detail}) {
        this.INPUT_ELEMENT.checked = detail.open
      }
    }
    customElements.define('td-cylindo-open-trigger', TDCylindoOpenTrigger);
  }

})()
